module.exports = __webpack_public_path__ + "static/media/Edutation_ePoster.dfc17012.jpg";